import React from 'react'
import { ButtonLoadingSeeker } from '@ui-seeker/core'
import { areCommonFiltersValid } from '@signals/commonFilters/filters'
import { Box } from '@mui/material'
import { useToast } from '@hooks'
import { isSearching } from 'Pages/RealTimeHistory/RealTime/@signals'
import { isLoadingCommonFilters } from '@signals'
import { filterSearchButtonProps, secondaryButtonSx } from "@components"


export default function RealTimeFiltersFooterActions() {

	const { showToast } = useToast()

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1.5 }}>
		<ButtonLoadingSeeker
			// the height and corners of Search beside it
			sx={{ ...secondaryButtonSx, height: 40, borderRadius: '10px' }}
			disabled={!isSearching.value}
			onClick={() => {
				isSearching.value = false
				showToast.info("Stopping Search!")
			}}
		>
			Stop Search
		</ButtonLoadingSeeker>
		<ButtonLoadingSeeker
			loading={isSearching.value || isLoadingCommonFilters.value}
			{...filterSearchButtonProps}
			onClick={() => {
				isLoadingCommonFilters.value = true
			}}
			disabled={!areCommonFiltersValid.value || isSearching.value || isLoadingCommonFilters.value}
		>
			Search
		</ButtonLoadingSeeker>
	</Box>
}